import { render, staticRenderFns } from "./AtomContentSliderBrochure.vue?vue&type=template&id=d41d8fa4&scoped=true&"
import script from "./AtomContentSliderBrochure.vue?vue&type=script&lang=js&"
export * from "./AtomContentSliderBrochure.vue?vue&type=script&lang=js&"
import style0 from "./AtomContentSliderBrochure.vue?vue&type=style&index=0&id=d41d8fa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41d8fa4",
  null
  
)

export default component.exports